import React from "react";
import styled from "@emotion/styled";
import PropTypes from "prop-types";

const themes = ["black_yellow", "blue_white", "yellow_black", "white_black", "white_blue"];
const sizes = ["mini", "regular", "mobile"];

const ButtonStyle = styled.button`
    label: ButtonStyle;
    
    border-radius: 8px;
    color: #333333;
    display: inline-flex;
    justify-content: center;
    line-height: 19px;
    margin: 5px;
    text-align: center;
    text-decoration: none;
    transition: all 0.1s ease-in-out;
    
    // Marked as important because of style bleed from LESS.
    text-transform: uppercase !important;
    font-family: Effra, sans-serif !important;
    font-size: 16px !important;
    font-weight: bold !important;
    letter-spacing: 4px !important;
    

    &:hover {
        text-decoration: none;
        cursor: pointer;
    }

// SIZE OPTIONS
 ${(props) => props.size === "mini" && "padding: .5em 2.5em"}}
 ${(props) => props.size === "regular" && "padding: 1.3em 2.5em"}}
 ${(props) => props.size === "mobile" && "padding: 1.3em 7.5em"}}
 
// THEME OPTIONS
// The "!important" callouts can be removed once all of the css is removed from the 
// project.  Style bleed makes this hard to style accurately without the "!important"
 ${(props) =>
     props.theme === "black_yellow" && {
         backgroundColor: "#262626 !important",
         border: "3px solid #262626 !important",
         borderRadius: "8px !important",
         color: "#F0C433 !important",
         "&:hover": {
             backgroundColor: "#262626 !important",
             border: "3px solid #262626 !important",
             color: "#F0C433 !important"
         }
     }}}
 ${(props) =>
     props.theme === "blue_white" && {
         border: "3px solid #0098DB !important",
         borderRadius: "8px !important",
         backgroundColor: "#0098DB !important",
         color: "#ffffff !important",
         "&:hover": {
             backgroundColor: "#377EB3 !important",
             border: "3px solid #377EB3 !important",
             color: "#ffffff !important"
         }
     }};
${(props) =>
    props.theme === "yellow_black" && {
        backgroundColor: "#F0C433 !important",
        border: "3px solid #F0C433 !important",
        borderRadius: "8px !important",
        color: "#262626 !important",
        "&:hover": {
            backgroundColor: "#D7B12C !important",
            border: "3px solid #D7B12C !important",
            color: "#262626 !important"
        }
    }}
${(props) =>
    props.theme === "white_black" && {
        backgroundColor: "transparent !important",
        border: "3px solid #262626 !important",
        borderRadius: "8px !important",
        color: "#262626 !important",
        "&:hover": {
            backgroundColor: "#262626 !important",
            border: "3px solid #262626 !important",
            color: "#FFFFFF !important"
        }
    }}
${(props) =>
    props.theme === "white_blue" && {
        backgroundColor: "transparent !important",
        border: "3px solid #0098DB !important",
        borderRadius: "8px !important",
        color: "#0098DB !important",

        "&:hover": {
            backgroundColor: "#0098DB !important",
            border: "3px solid #0098DB !important",
            color: "#FFFFFF !important"
        }
    }}
`;

const ButtonStyled = ({ onClick, children, size, theme, text, destination, new_window, dataQa }, extraProps) => {
    if (onClick) {
        return (
            <ButtonStyle
                data-qa={dataQa}
                as="a"
                type="button"
                size={size}
                theme={theme}
                onMouseDown={onClick}
                onKeyDown={onClick}
                {...extraProps}
            >
                {text} {children}
            </ButtonStyle>
        );
    }
    if (new_window) {
        return (
            <ButtonStyle
                as="a"
                href={destination}
                target="_blank"
                rel="noopener"
                data-qa={dataQa}
                size={size}
                theme={theme}
                {...extraProps}
            >
                {text} {children}
            </ButtonStyle>
        );
    }
    return (
        <ButtonStyle as="a" data-qa={dataQa} size={size} href={destination} theme={theme} {...extraProps}>
            {text} {children}
        </ButtonStyle>
    );
};
ButtonStyled.defaultProps = {
    theme: "blue",
    size: "regular",
    text: ""
};
ButtonStyled.propTypes = {
    onClick: PropTypes.func,
    theme: PropTypes.oneOf(themes),
    size: PropTypes.oneOf(sizes),
    text: PropTypes.string,
    destination: PropTypes.string,
    new_window: PropTypes.bool
};

export default ButtonStyled;
